export default function decideShouldRenderMore(
  postsToRenderCount,
  fetchedPostsCount,
  postCount,
  columns,
  shouldFetchMore,
) {
  if (postsToRenderCount + columns <= Math.min(fetchedPostsCount, postCount)) {
    return true
  }
  return shouldFetchMore
}
